'use client';

import { BunkerProvider } from '@/providers/BunkerProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { Container, Grid, Modal, ScrollArea, SimpleGrid, Stack } from '@mantine/core';
import { Icons } from '../Shares/Icons';
import { BunkerEquipSection } from './BunkerEquipSection';
import { BunkerInventorySection } from './BunkerInventorySection';
import { BunkerMainSection } from './BunkerMainSection';
import classes from './BunkerModal.module.css';
import { BunkerRewardsSection } from './BunkerRewardsSection';
export const BunkerModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.BUNKER} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.96)'
  }} size="100%" classNames={classes}>
      <BunkerProvider>
        <Container size="xl">
          <SimpleGrid cols={1} spacing={16}>
            <Grid gutter={{
            sm: 28,
            lg: 16
          }}>
              <Grid.Col span={{
              base: 12,
              sm: 5,
              lg: 3
            }} order={{
              base: 2,
              sm: 1
            }} mt={{
              sm: -60,
              md: 0
            }} bg={{
              sm: 'var(--bg-200)',
              lg: 'transparent'
            }}>
                <ScrollArea h={{
                sm: 1050,
                lg: '100%'
              }} offsetScrollbars scrollbarSize={5} className={classes.mask}>
                  <Stack gap={48} pt={{
                  sm: 20,
                  lg: 0
                }} pr={{
                  base: 8,
                  lg: 0
                }}>
                    <BunkerEquipSection visibleFrom="sm" />
                    <BunkerRewardsSection hiddenFrom="lg" />
                  </Stack>
                </ScrollArea>
              </Grid.Col>
              <Grid.Col span={{
              base: 12,
              sm: 7,
              lg: 6
            }} order={{
              base: 1,
              sm: 2
            }}>
                <Stack gap={32}>
                  <BunkerMainSection />
                  <BunkerInventorySection hiddenFrom="lg" />
                </Stack>
              </Grid.Col>
              <Grid.Col span={{
              base: 12,
              lg: 3
            }} order={3} visibleFrom="lg">
                <BunkerInventorySection />
              </Grid.Col>
            </Grid>

            <BunkerRewardsSection visibleFrom="lg" />
          </SimpleGrid>
        </Container>
      </BunkerProvider>
    </Modal>;
};